import React from 'react';
import { SkeletonLine, SkeletonBlock, SkeletonCircle } from '../components/common/Skeleton.jsx';

/**
 * Loading placeholder for a single users-list row, shaped to match
 * AdminUserRow exactly (same `.admin-user-row` / `.admin-user-card`
 * classes) so the table/cards don't jump around once real data replaces it.
 */
function AdminUserRowSkeleton({ isMobile }) {
  if (isMobile) {
    return (
      <div className="admin-user-card-wrapper" aria-hidden="true">
        <div className="admin-user-card">
          <div className="admin-user-card-header">
            <SkeletonLine width="55%" height={16} />
            <SkeletonBlock width={92} height={26} radius={20} />
          </div>
          <div className="admin-user-card-body">
            {['Email', 'Username', 'Department', 'Status', 'Projects'].map((label) => (
              <div className="admin-user-card-row" key={label}>
                <span className="admin-user-card-label">{label}</span>
                <SkeletonLine width="65%" height={12} />
              </div>
            ))}
          </div>
          <div className="admin-user-actions">
            {Array.from({ length: 4 }).map((_, i) => (
              <SkeletonCircle key={i} size={32} />
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-user-row" aria-hidden="true">
      <SkeletonLine width="75%" height={14} />
      <SkeletonLine width="85%" height={14} />
      <SkeletonLine width="65%" height={14} />
      <SkeletonBlock width="80%" height={24} radius={20} />
      <SkeletonBlock width="70%" height={22} radius={20} />
      <SkeletonBlock width="65%" height={20} radius={12} />
      <SkeletonLine width="55%" height={14} />
      <div className="admin-user-actions">
        {Array.from({ length: 4 }).map((_, i) => (
          <SkeletonCircle key={i} size={28} />
        ))}
      </div>
    </div>
  );
}

export default React.memo(AdminUserRowSkeleton);
